import { useFormatter, useTranslations } from 'next-intl';

function useFormattedDateLabel(namespace: string, date: Date, baseKey: string): string {
  const t = useTranslations(namespace);
  const format = useFormatter();
  // Derive day/year from the same (locale, timeZone)-aware formatter used to render `date`,
  // rather than the runtime's local timezone - otherwise day/month/year can desync near
  // midnight when the runtime timezone differs from the configured display timeZone.
  const day = Number(format.dateTime(date, { day: 'numeric' }));
  const year = format.dateTime(date, { year: 'numeric' });
  const currentYear = format.dateTime(new Date(), { year: 'numeric' });
  const key = year === currentYear ? baseKey : `${baseKey}_with_year`;
  return t(key, { date, day });
}

export { useFormattedDateLabel };
